<template>
  <!-- 过渡动画：淡入淡出 + 右侧滑入滑出 -->
  <transition name="notification-fade" @after-leave="handleAfterLeave">
    <div 
      class="notification" 
      :class="`notification--${type}`"
      v-show="visible"
    >
      <!-- 通知图标 -->
      <div class="notification__icon" v-if="type">
        <span v-if="type === 'success'">✓</span>
        <span v-if="type === 'info'">ℹ</span>
        <span v-if="type === 'warning'">⚠</span>
        <span v-if="type === 'error'">✗</span>
      </div>
      <!-- 通知内容 -->
      <div class="notification__content">
        <h3 class="notification__title" v-if="title">{{ title }}</h3>
        <p class="notification__message" v-if="message">{{ message }}</p>
      </div>
      <!-- 关闭按钮 -->
      <!-- <div class="notification__close" @click="handleClose">×</div> -->
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Notification',
  // Vue2的Props定义方式
  props: {
    // 通知标题
    title: {
      type: String,
      default: ''
    },
    // 通知内容
    message: {
      type: String,
      required: true
    },
    // 通知类型（success/info/warning/error）
    type: {
      type: String,
      default: 'info',
      validator: function(val) {
        // Vue2的Props验证器写法
        return ['success', 'info', 'warning', 'error'].includes(val)
      }
    },
    // 自动关闭时长（毫秒，0表示不自动关闭）
    duration: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      // Vue2响应式数据：通知可见性
      visible: true,
      // 自动关闭定时器标识（挂载到实例，方便销毁）
      timer: null
    }
  },
  // Vue2生命周期钩子：组件挂载完成
  mounted() {
    // 启动自动关闭定时器
    if (this.duration > 0) {
      this.timer = setTimeout(() => {
        this.handleClose()
      }, this.duration)
    }
  },
  // Vue2生命周期钩子：组件卸载前（清除定时器，防止内存泄漏）
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  methods: {
    // 手动关闭通知（触发过渡动画）
    handleClose() {
      this.visible = false
    },
    // 过渡动画结束后：通知父级移除组件
    handleAfterLeave() {
      // Vue2通过$emit触发自定义事件
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
/* 过渡动画样式（Vue2完全兼容该写法） */
.notification-fade-enter-active,
.notification-fade-leave-active {
  transition: all 0.3s ease;
}
.notification-fade-enter {
  opacity: 0;
  transform: translateX(20px);
}
.notification-fade-enter-to {
  opacity: 1;
  transform: translateX(0);
}
.notification-fade-leave {
  opacity: 1;
  transform: translateX(0);
}
.notification-fade-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

/* 通知组件基础样式 */
.notification {
  position: relative;
  width: 6rem;
  padding: 0.2rem;
  margin-bottom: 0.1rem;
  border-radius: 0.1rem;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  cursor: default;
  z-index: 9999;
}

/* 不同类型通知的主题样式 */
.notification--success {
  border-left: 4px solid #67c23a;
}
.notification--info {
  border-left: 4px solid #409eff;
}
.notification--warning {
  border-left: 4px solid #e6a23c;
}
.notification--error {
  border-left: 4px solid #f56c6c;
}

/* 图标样式 */
.notification__icon {
  font-size: 0.4rem;
  margin-right: 1rem;
}
.notification--success .notification__icon {
  color: #67c23a;
}
.notification--info .notification__icon {
  color: #409eff;
}
.notification--warning .notification__icon {
  color: #e6a23c;
}
.notification--error .notification__icon {
  color: #f56c6c;
}

/* 内容样式 */
.notification__content {
  flex: 1;
  overflow: hidden;
}
.notification__title {
  margin: 0 0 4px 0;
  font-size: 0.3rem;
  font-weight: 500;
  color: #333;
}
.notification__message {
  margin: 0;
  font-size: 0.3rem;
  color: #666;
}

/* 关闭按钮样式（预留） */
.notification__close {
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 16px;
  color: #999;
  cursor: pointer;
  transition: color 0.2s ease;
}
.notification__close:hover {
  color: #333;
}
</style>